import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';
import AppHeader from '../components/AppHeader';
import { PRIVACY_FULL, LAST_UPDATED_EN, LAST_UPDATED_AR } from '../data/legalContent';
import './LegalPages.css';

/**
 * iter306 — Full Privacy Policy page.
 * Public route. Bilingual (EN/AR). Mobile-first. RTL/LTR safe.
 */
export default function PrivacyPolicy() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language?.startsWith('ar');
  const lang = isRTL ? 'ar' : 'en';
  const doc = PRIVACY_FULL[lang];
  const lastUpdated = isRTL ? LAST_UPDATED_AR : LAST_UPDATED_EN;

  return (
    <div className="legal-page" dir={isRTL ? 'rtl' : 'ltr'} data-testid="privacy-policy-page">
      <AppHeader title={doc.title} backFallback="/" testId="privacy-header" />
      <div className="legal-container">
        <div className="legal-header">
          <div className="legal-icon-wrapper">
            <ShieldCheck size={32} />
          </div>
          <h1 className="legal-title" data-testid="privacy-title">
            {doc.title}
          </h1>
          <p className="legal-subtitle" data-testid="privacy-last-updated">
            {isRTL ? `آخر تحديث: ${lastUpdated}` : `Last updated: ${lastUpdated}`}
          </p>
          <p className="legal-intro">{doc.intro}</p>
        </div>

        <div className="legal-content" data-testid="privacy-content">
          {doc.sections.map((s, i) => (
            <section className="legal-section" key={i} data-testid={`privacy-section-${i + 1}`}>
              <h2>{s.h}</h2>
              <p>{s.p}</p>
            </section>
          ))}
        </div>

        <div className="legal-footer-links" data-testid="privacy-footer-links">
          <Link to="/terms" data-testid="privacy-link-terms">
            {isRTL ? 'شروط الاستخدام' : 'Terms of Use'}
          </Link>
          <span aria-hidden="true"> · </span>
          <Link to="/delete-account" data-testid="privacy-link-delete">
            {isRTL ? 'حذف الحساب' : 'Delete Account'}
          </Link>
        </div>
      </div>
    </div>
  );
}
